export namespace MediaDevice {
    export type Id = string;
    export type Tag = string;

    export type Status = {
        started: boolean;
        resolution?: string;
    }

    export type PredefinedResolution = 'FHD' | 'HD' | 'VGA' | 'QVGA';

    export function isPredefinedResolution(s: string): s is PredefinedResolution {
        let flag = false;
        switch (s as PredefinedResolution) {
            case 'FHD': flag = true; break;
            case 'HD': flag = true; break;
            case 'VGA': flag = true; break;
            case 'QVGA': flag = true; break;
        }
        return flag;
    }

    export type VideoResolution = PredefinedResolution;

    export type VideoCodec = 'VP8' | 'VP9' | 'H264';

    export function isKnownVideoCodec(s: string): s is VideoCodec {
        let flag = false;
        switch (s as VideoCodec) {
            case 'VP8':
                flag = true;
                break;
            case 'VP9':
                flag = true;
                break;
            case 'H264':
                flag = true;
                break;
        }
        return flag;
    }

    export type VideoConfig = {
        enabled: boolean;
        minBitrate: number | undefined;
        maxBitrate: number | undefined;
        framerate: number | undefined;
        resolution: VideoResolution;
    } & ({ codec: VideoCodec } | { unknownCodec: string });

    export type AudioCodec = 'OPUS';

    export function isKnownAudioCodec(s: string): s is AudioCodec {
        let flag = false;
        switch (s as AudioCodec) {
            case 'OPUS':
                flag = true;
                break;
        }
        return flag;
    }

    export type AudioConfig = {
        enabled: boolean;
        minBitrate: number | undefined;
        maxBitrate: number | undefined;
    } & ({ codec: AudioCodec } | { unknownCodec: string });
}

export type CameraDevice = {
    type: 'camera';
    id: MediaDevice.Id;
    tag: MediaDevice.Tag;
}

export function makeCameraDevice(values: Omit<CameraDevice, 'type'>): CameraDevice {
    return { ...values, type: 'camera' };
}

export type MicrophoneDevice = {
    type: 'microphone';
    id: MediaDevice.Id;
    tag: MediaDevice.Tag;
}

export function makeMicrophoneDevice(values: Omit<MicrophoneDevice, 'type'>): MicrophoneDevice {
    return { ...values, type: 'microphone' };
}

export type MediaDevice = CameraDevice | MicrophoneDevice;
